import DataDisplayRowI from "../DataDisplayRowI";
import getDealerRebateRow from "../DataDisplayRow/DealerRebateRow";
import DataDisplayTable from "../DataDisplayTable";

class DealerRebateTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getDealerRebateRow()
    }
}

let dealerRebateTable: DealerRebateTable | null = null;

export default function getDealerRebateTable(): DealerRebateTable {
    if (dealerRebateTable === null)
        dealerRebateTable = new DealerRebateTable()
    return dealerRebateTable
}